/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/search_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/checkmark--filled_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/caret--up_32',
	'./VisGraphics',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/change-visualization_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/checkmark--outline_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/circle_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/diamond_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/face--satisfied_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/face--neutral_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/face--dissatisfied_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/report_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/dash_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/dashboard_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/catalog_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/data-format_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/events_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/view--off_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/view_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/restart_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/delete_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/reset_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/repeat_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/suppress-nulls_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/add_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/add--filled_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/plus_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/subtract_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/code-file_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/information_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--custom_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/potential-drivers_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/play_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/pause_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/filter-applied_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/filter--edit_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/warning--filled_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/resize-panel_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/subtract--alt_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/drill-back_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/drill-down_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/compass_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-color-by_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-x-axis_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-y-axis_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-value_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-multiplier-h_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-multiplier-v_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-row-heading-crosstab_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-column-heading-crosstab_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-points_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-heat-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-size-by_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-target_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-level_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-pie-category_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-bubbles_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-x-axis-bars_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-key_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-width_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-y-axis-columns_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-word_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-radial-bar-category_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/location_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-point-heat_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-category_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/favorite_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/time_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/link_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-source_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/user_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/table_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/text--creation_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/disable_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/checkmark_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/filter_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/summarize_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/data-bin_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/edit_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/calculation_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrows--vertical_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/top-bottom_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/function-summary_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrows--horizontal_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/marquee_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/circle-dash_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/lasso--polygon_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/drill-through_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/database_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/data--unstructured_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/upload_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/data-set_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/warning_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/warning--alt--filled--colored_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/error--filled_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrow--left_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chevron-left_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrow--up_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrow--down_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/time_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chevron-right_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chevron-right_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chevron-up_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chevron-down_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/disable_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/close_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/resize-panel_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/arrow--right_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/analytics_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/delete_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/idea_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-to_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/slot-from_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/schematic_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/draggable_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/svg-file_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/up-to-top_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/caret--up_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/caret--down_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/caret--right_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/triangle_16',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/x-symbol_16'

], function(
	search16,
	checkmarkfilled16,
	caretUp32,
	VisGraphics,
	changevisualization16,
	checkmarkOutline16,
	circle16,
	diamond16,
	faceSatisfied32,
	faceNeutral32,
	faceDisSatisfied32,
	report16,
	dash16,
	dashboarddisplay32,
	catalog32,
	format16,
	events32,
	hide16,
	show16,
	restart16,
	delete16,
	restore16,
	repeat32,
	suppressNulls16,
	add16,
	addFilled16,
	plus24,
	subtract32,
	codeFile32,
	information16,
	overflowMenuHorizontal32,
	customVisual32,
	potentialDrivers16,
	play32,
	pause32,
	filterApplied16,
	filterEdit32,
	warn32,
	resizePanel24,
	remove32,
	drillBack16,
	drillDown16,
	compass32,
	slotColorBy32,
	slotXAxis32,
	slotYAxis32,
	slotValues32,
	slotMultiplierH32,
	slotMultiplierV32,
	slotRowHeading32,
	slotColumnHeading32,
	slotPoints32,
	slotHeatMap32,
	slotSizeBy32,
	slotTarget32,
	slotLevel32,
	slotPieCategorySlice32,
	slotBubbles32,
	slotXAxisBars32,
	slotKey32,
	slotWidth32,
	slotYAxisColumn32,
	slotWord32,
	slotRadialBarCategory32,
	location32,
	slotPointHeat32,
	slotCategory32,
	favorite32,
	time32,
	link32,
	slotSource32,
	user32,
	table16,
	textCreation32,
	disable16,
	checkmark16,
	filter16,
	summarize16,
	dataBin16,
	edit16,
	calculation16,
	arrowsVertical16,
	topBottom16,
	functionSummary16,
	arrowsHorizontal32,
	selection16,
	circleDash32,
	lassoPolygon32,
	drillThrough16,
	database32,
	dataModel24,
	upload32,
	dataSet32,
	warning16,
	warning16Colored,
	error24,
	arrowLeft32,
	chevronLeft32,
	arrowUp16,
	arrowDown16,
	clock32,
	chevronRight16,
	chevronRight32,
	chevronUp16,
	chevronDown16,
	disable32,
	close16,
	resizePanel16,
	arrowRight16,
	forecast16,
	delete32,
	idea32,
	slotTo32,
	slotFrom32,
	schematic32,
	draggable32,
	svgFile16,
	overflowVertical,
	upToTop16,
	caretUp,
	caretDown32,
	caretRight32,
	triangle16,
	xsymbol16
) {
	'use strict';

	return class LiveWidgetIconsProvider{
		constructor({ features }){
			//features.API
			const _liveWidgetIcons = this._liveWidgetIconList();
			const _graphicsForVis = VisGraphics.graphicsList();
			const LiveWidgetIconList = [..._liveWidgetIcons, ..._graphicsForVis];
			/**
			 * Icons that are currently not in ba-graphics:
			 * Remove Shape icon
			 */
			features.Icons.registerIcons(LiveWidgetIconList);
		}

		_liveWidgetIconList(){
			return [
				{
					id: 'searchIcon',
					icon: search16
				}, {
					id: 'CheckmarkSVG',
					icon: checkmarkfilled16
				}, {
					id: 'upCaret',
					icon: caretUp32
				}, {
					id: 'visualizations-changeVisualization',
					icon: changevisualization16
				}, {
					id: 'checkmark',
					icon: checkmarkOutline16
				}, {
					id: 'circle',
					icon: circle16
				}, {
					id: 'diamond',
					icon: diamond16
				}, {
					id: 'satisfied',
					icon: faceSatisfied32
				}, {
					id: 'neutral',
					icon: faceNeutral32
				}, {
					id: 'dissatisfied',
					icon: faceDisSatisfied32
				}, {
					id: 'reportIcon',
					icon: report16
				}, {
					id: 'dash',
					icon: dash16
				}, {
					id: 'dashboardIcon',
					icon: dashboarddisplay32
				}, {
					id: 'storyIcon',
					icon: catalog32
				}, {
					id: 'format16',
					icon: format16
				}, {
					id: 'GroupIcon',
					icon: events32
				}, {
					id: 'iconHide',
					icon: hide16
				}, {
					id: 'iconView',
					icon: show16
				}, {
					id: 'refreshIcon',
					icon: restart16
				}, {
					id: 'TrashIcon',
					icon: delete16
				}, {
					id: 'ReverseIcon',
					icon: repeat32
				}, {
					id: 'RestoreIcon',
					icon: restore16
				}, {
					id: 'iconSuppresion',
					icon: suppressNulls16
				}, {
					id: 'add16',
					icon: add16
				}, {
					id: 'addNew',
					icon: addFilled16
				}, {
					id: 'plus',
					icon: plus24
				}, {
					id: 'subtract',
					icon: subtract32
				}, {
					id: 'codeFile',
					icon: codeFile32
				}, {
					id: 'getInformation',
					icon: information16
				}, {
					id: 'overflowMenuHorizontal32',
					icon: overflowMenuHorizontal32
				}, {
					id: 'customVisual',
					icon: customVisual32
				}, {
					id: 'potentialDrivers',
					icon: potentialDrivers16
				}, {
					id: 'playIcon',
					icon: play32
				}, {
					id: 'pauseIcon',
					icon: pause32
				}, {
					id: 'filterApplied',
					icon: filterApplied16
				}, {
					id: 'filterEdit32',
					icon: filterEdit32
				}, {
					id: 'warnIcon',
					icon: warn32
				}, {
					id: 'resizePanel',
					icon: resizePanel24
				}, {
					id: 'remove',
					icon: remove32
				}, {
					id: 'dashboard-navigation-drillback',
					icon: drillBack16
				},{
					id:'dashboard-navigation-drilldown',
					icon: drillDown16
				}, {
					id: 'dashboard-navigation-compass',
					icon: compass32
				}, {
					id: 'colorBy',
					icon: slotColorBy32
				}, {
					id: 'xAxis',
					icon: slotXAxis32
				}, {
					id: 'yAxis',
					icon: slotYAxis32
				}, {
					id: 'values',
					icon: slotValues32
				}, {
					id: 'multiplier_h',
					icon: slotMultiplierH32
				}, {
					id: 'multiplier_v',
					icon: slotMultiplierV32
				}, {
					id: 'row_heading',
					icon: slotRowHeading32
				}, {
					id: 'column_heading',
					icon: slotColumnHeading32
				}, {
					id: 'points',
					icon: slotPoints32
				}, {
					id: 'heat_map',
					icon: slotHeatMap32
				}, {
					id: 'size_by',
					icon: slotSizeBy32
				}, {
					id: 'target',
					icon: slotTarget32
				}, {
					id: 'level',
					icon: slotLevel32
				}, {
					id: 'pie_category_slice',
					icon: slotPieCategorySlice32
				}, {
					id: 'bubbles',
					icon: slotBubbles32
				}, {
					id: 'x-axis_bars',
					icon: slotXAxisBars32
				}, {
					id: 'key',
					icon: slotKey32
				}, {
					id: 'width',
					icon: slotWidth32
				}, {
					id: 'y-axis_columns',
					icon: slotYAxisColumn32
				}, {
					id:'word',
					icon: slotWord32
				}, {
					id: 'radialbar_category',
					icon: slotRadialBarCategory32
				}, {
					id: 'location',
					icon: location32
				}, {
					id: 'point_heat',
					icon: slotPointHeat32
				},{
					id: 'text',
					icon: slotCategory32
				}, {
					id: 'like',
					icon: favorite32
				}, {
					id: 'category',
					icon: slotCategory32
				}, {
					id: 'time',
					icon: time32
				}, {
					id: 'link',
					icon: link32
				}, {
					id: 'source',
					icon: slotSource32
				}, {
					id: 'user',
					icon: user32
				}, {
					id: 'from',
					icon: slotFrom32
				}, {
					id: 'to',
					icon: slotTo32
				}, {
					id: 'lineweight',
					icon: slotWidth32
				}, {
					id: 'common-querySubject',
					icon: table16
				}, {
					id: 'common-text-edit',
					icon: textCreation32
				}, {
					id: 'wfg_filter_exclude',
					icon: disable16
				}, {
					id: 'wfg_filter_keep',
					icon: checkmark16
				}, {
					id: 'common-filter',
					icon: filter16
				}, {
					id: 'dashboard-aggregate',
					icon: summarize16
				}, {
					id: 'dashboard-autobin',
					icon: dataBin16
				}, {
					id: 'common-edit',
					icon: edit16
				}, {
					id: 'dashboard-calculate',
					icon: calculation16
				}, {
					id: 'common-remove-trash',
					icon: delete32
				}, {
					id: 'common-sort-icon',
					icon: arrowsVertical16
				}, {
					id: 'dashboard-topbottom',
					icon: topBottom16
				}, {
					id: 'dashboard-hideshowsummaries',
					icon: functionSummary16
				}, {
					id: 'dashboard-swap',
					icon: arrowsHorizontal32
				}, {
					id: 'visualizations-marquee_16',
					icon: selection16
				},{
					id: 'circle_dash_32',
					icon: circleDash32
				},{
					id: 'lasso_polygon_32',
					icon: lassoPolygon32
				}, {
					id: 'visualizations-drillthrough_16',
					icon: drillThrough16
				}, {
					id: 'common-data_source',
					icon: database32
				}, {
					id: 'common-titan-model',
					icon: dataModel24
				}, {
					id: 'common-upload',
					icon: upload32
				}, {
					id: 'common-dataset',
					icon: dataSet32
				}, {
					id: 'common-warning',
					icon: warning16
				}, {
					id: 'warning',
					icon: warning16
				}, {
					id: 'minor-warning',
					icon: warning16Colored
				}, {
					id: 'critical',
					icon: error24
				}, {
					id: 'common-previous',
					icon: arrowLeft32
				}, {
					id: 'common-chevron_left',
					icon: chevronLeft32
				}, {
					id: 'arrowUp',
					icon: arrowUp16
				}, {
					id: 'upArrow',
					icon: arrowUp16
				}, {
					id: 'arrowDown',
					icon: arrowDown16
				}, {
					id: 'downArrow',
					icon: arrowDown16
				}, {
					id: 'common-clock-time',
					icon: clock32
				}, {
					id: 'common-chevron_right_16',
					icon: chevronRight16
				}, {
					id: 'common-chevron_right',
					icon: chevronRight32
				}, {
					id: 'common-chevron_up_16',
					icon: chevronUp16
				}, {
					id: 'common-chevron_down_16',
					icon: chevronDown16
				}, {
					id: 'common-nodrop',
					icon: disable32
				}, {
					id: 'common-close_16',
					icon: close16
				}, {
					id: 'common-handle',
					icon: resizePanel16
				}, {
					id: 'arrowRight',
					icon: arrowRight16
				}, {
					id: 'rightArrow',
					icon: arrowRight16
				}, {
					id: 'forecast',
					icon: forecast16
				}, {
					id: 'common-insights',
					icon: idea32
				}, {
					id: 'schematicVisual',
					icon: schematic32
				}, {
					id: 'draggable_32',
					icon: draggable32
				}, {
					id: 'svgFile',
					icon: svgFile16
				}, {
					id: 'overflowVertical',
					icon: overflowVertical
				}, {
					id: 'upToTop',
					icon: upToTop16
				}, {
					id: 'caretUp',
					icon: caretUp
				}, {
					id: 'caretDown32',
					icon: caretDown32
				}, {
					id: 'downCaret',
					icon: caretDown32
				}, {
					id: 'caretRight32',
					icon: caretRight32
				}, {
					id: 'codeFile32',
					icon: codeFile32
				}, {
					id: 'triangle',
					icon: triangle16
				}, {
					id: 'xSymbol',
					icon: xsymbol16
				}
			];
		}
	};
});
